<template>
  <div class="praise-banner">
    <!--    <div class="img">-->
    <svg v-if="discussItem.curClass != 'news_comment_praise_img_active'"
         xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 85 85"
         @click="clickPares(discussItem.curClass == 'news_comment_praise_img_active' ? '' : discussItem, 1)">
      <path fill-rule="evenodd" stroke-width="2px" stroke-linecap="butt" stroke-linejoin="miter" fill="none"
            d="M42.000,1.000 C64.644,1.000 83.000,19.356 83.000,42.000 C83.000,64.644 64.644,83.000 42.000,83.000 C19.356,83.000 1.000,64.644 1.000,42.000 C1.000,19.356 19.356,1.000 42.000,1.000 Z"/>
      <path fill-rule="evenodd"
            d="M61.007,33.713 L47.838,33.713 C47.355,33.713 47.541,33.403 48.429,31.333 C49.189,29.560 49.632,28.327 49.687,26.581 C49.806,22.791 47.719,18.176 44.653,18.260 C39.362,18.407 39.973,21.537 39.067,25.205 C38.266,28.431 37.028,31.939 34.589,33.713 C32.199,34.600 34.314,34.902 25.781,34.902 C24.180,34.902 23.264,35.916 23.264,37.278 L23.260,58.903 C23.260,60.301 23.749,61.034 25.526,61.034 L57.039,61.049 C57.244,61.049 58.533,60.947 59.352,60.484 C60.773,59.681 61.009,58.673 61.009,58.673 L66.041,38.468 C66.030,36.809 64.786,33.710 61.009,33.710 L61.007,33.713 L61.007,33.713 ZM25.784,58.673 L25.784,37.278 C25.784,37.278 28.978,37.297 30.817,37.293 L30.817,58.673 L25.781,58.673 L25.784,58.673 L25.784,58.673 ZM63.526,38.466 C63.408,38.941 58.495,57.482 58.495,57.482 C58.115,58.284 58.052,58.673 57.235,58.673 L33.331,58.673 L33.331,36.960 C34.255,36.674 35.328,36.284 35.849,36.089 C38.241,34.329 39.346,32.257 40.882,28.957 C42.417,25.665 41.127,20.926 44.656,20.638 C45.913,20.536 47.709,23.840 47.172,26.581 C46.092,32.090 44.929,31.653 44.656,33.713 C44.656,34.823 45.921,36.089 47.172,36.089 L61.009,36.089 C62.910,36.089 63.712,37.743 63.526,38.468 L63.526,38.466 L63.526,38.466 Z"/>
    </svg>

    <svg v-else xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 85 85">
      <path fill-rule="evenodd" fill=""
            d="M60.927,33.576 L47.693,33.576 C47.208,33.576 47.396,33.266 48.286,31.190 C49.051,29.411 49.497,28.175 49.552,26.424 C49.671,22.625 47.574,17.996 44.493,18.080 C39.176,18.228 39.791,21.367 38.880,25.045 C38.075,28.280 36.832,31.797 34.379,33.576 C31.979,34.466 34.103,34.769 25.529,34.769 C23.922,34.769 23.000,35.786 23.000,37.152 L22.996,58.836 C22.996,60.237 23.488,60.973 25.274,60.973 L56.940,60.988 C57.145,60.988 58.441,60.886 59.263,60.423 C60.690,59.616 60.929,58.604 60.929,58.604 L65.986,38.345 C65.973,36.682 64.723,33.574 60.929,33.574 L60.927,33.576 L60.927,33.576 ZM33.117,60.991 L30.590,60.991 L30.590,34.676 C30.590,34.676 32.268,34.692 33.117,34.178 L33.117,60.991 Z"/>
      <path fill-rule="evenodd" stroke="" stroke-width="2px" stroke-linecap="butt" stroke-linejoin="miter" fill="none"
            d="M42.000,1.000 C64.644,1.000 83.000,19.356 83.000,42.000 C83.000,64.644 64.644,83.000 42.000,83.000 C19.356,83.000 1.000,64.644 1.000,42.000 C1.000,19.356 19.356,1.000 42.000,1.000 Z"/>
    </svg>
      <p v-show="discussItem.praiseCount>0">{{discussItem.praiseCount|parseCount}}</p>
  </div>
</template>

<script>
  import utils from '../../tool/utils'
  import submit from '../../tool/submit'

  export default {
    name: 'praiseDanner',
    props: ['discussItem'],
    filters: {
      parseCount: function (t) {
        if (!t) return
        return utils.parseCount(t)
      }
    },
    methods: {
      clickPares: function (item, n) {
        if (!item) return
        var id = item.discussID
        if ((localStorage.getItem('topicCommentPraise') || '').indexOf(id) > -1) return
        var _this = this

        var data = {
          sid: _this.$route.params.sid,
          discussID: id,
          uid: 0
        }
        submit.clickPraise(data, n).then((res) => {
          if (res && res.data) {
            if (n) {
              // 参与评论点赞数
              if ((localStorage.getItem('topicDiscussPraise') || '').indexOf(id) === -1) {
                localStorage.setItem('topicDiscussPraise', (localStorage.getItem('topicDiscussPraise') || '') + '_' + id)
              }
              _this.discussItem.curClass = 'news_comment_praise_img_active'
              _this.discussItem.praiseCount = res.data.praiseCount
            }
          }
        }).catch((err) => {
          console.log('clickPares-result-err', err)
        })
      }
    }
  }
</script>

<style scoped>
  .praise-banner {
    text-align: center;
  }

  .praise-banner .img {
    display: block;
    width: 0.82rem;
    height: 0.82rem;
    padding-top: 0.28rem;
    margin: 0 auto;
  }

  .praise-banner svg {
    display: block;
    width: 0.82rem;
    height: 0.82rem;
    margin: 0 auto;
    margin-top: 0.28rem;
    fill: var(--themeColor);
    stroke: var(--themeColor);
  }

  .praise-banner p {
    font-size: 0.24rem;
    color: #999999;
    line-height: 0.48rem;
  }
</style>



// WEBPACK FOOTER //
// praiseDanner.vue?9a3a463c